export default [
  {
    path: "/friends",
    meta: { navbarTitle: "Freunde" },
    name: "Friends",
    component: () => import(/* webpackChunkName: "friends" */ "@/views/friends/Friends.vue"),
  },
]
